const ScrollHandler = {
  init: () => {
    const startScrollPos = window.scrollY;

    const body = document.querySelector("body");
    const header = document.querySelector(".header");
    const fairTransportLogo = document.getElementById("fair-transport");

    if (body && header) {
      if (startScrollPos >= 60) {
        body.classList.add("sticky");
        header.classList.add("sticky");

        // shrink fair transport logo
        if (fairTransportLogo) {
          fairTransportLogo.classList.add("fair-transport--is-small");
        }
      }
    }

    window.onscroll = () => {
      let scrollPos = window.scrollY;

      // collapse / expand header on scroll
      if (scrollPos >= 60) {
        body.classList.add("sticky");
        header.classList.add("sticky");

        // shrink fair transport logo
        if (fairTransportLogo) {
          fairTransportLogo.classList.add("fair-transport--is-small");
        }
      } else if (scrollPos < 60) {
        body.classList.remove("sticky");
        header.classList.remove("sticky");

        // reset fair transport logo
        if (fairTransportLogo) {
          fairTransportLogo.classList.remove("fair-transport--is-small");
        }
      }

      // check if element is visible in viewport
      // let reviews = document.querySelector(".swiper-reviews");
      // const reviewsVisible = ScrollHandler.viewportBounds(reviews);
      // console.log(`reviewsVisible: ${reviewsVisible}`);
    };
  },

  viewportBounds: (target) => {
    const viewport = {};
    viewport.top = window.scrollY;
    viewport.bottom = viewport.top + window.innerHeight;

    const bounds = {};
    bounds.top = target.offsetTop;
    bounds.bottom = bounds.top + target.offsetHeight;

    return bounds.top <= viewport.bottom && bounds.bottom >= viewport.top;
  },
};

export default ScrollHandler;
